export enum CreationSteps {
  setup = 1,
  tasks = 2,
  territories = 3,
  users = 4,
}
